module.exports = __webpack_public_path__ + "img/level.ad75e3f7.png";